import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./not-found.component').then(m => m.NotFoundComponent),
        data: { title: "Page Not Found" }
      }
    ]
  }
];
